import { signInWithPopup, signOut } from 'firebase/auth';
import { Toast } from '../../../components/Common/Toast';
import { encryptToken } from '../../../helper/helper';
import { AppDispatch } from '../../../store/store';
import { setSignupViaGoogle, setUser } from '../../../store/userSlice';
import { auth, provider } from '../../../firebase';
import { UserLocalStorageKeysEnum } from '../../../interfaces/user.interface';
import { TokenCookieManager } from '../../../utils/tokenCookies';
import { NavigateFunction } from 'react-router-dom';
import { autoFetchUserDetails } from '../../../store/thunks/user.thunk';
import { callAPI } from '../../../services/api.service';

export const handleGoogleLogin = async (
  setGoogleLoader: (value: boolean) => void,
  getUserDetails: (email: string) => Promise<any>,
  navigateTo: NavigateFunction,
  dispatch: AppDispatch,
  setSignUpStep?: (step: number) => void,
  promotionalEmail?: string,
  updateEmail?: any,
) => {
  try {
    setGoogleLoader(true);
    const result: any = await signInWithPopup(auth, provider);
    const email = result.user?.email!;
    const user = await getUserDetails(email);

    if (user === null || user?.payload === null) {
      signOut(auth)
        .then(() => {
          dispatch(setUser(null));
          TokenCookieManager.removeToken();
          localStorage.removeItem(UserLocalStorageKeysEnum.CURRENT_USER);
        })
        .catch((error) => {});
      return;
    }

    if (user) {
      dispatch(autoFetchUserDetails());
      dispatch(setUser({ ...result?.user!, ...user }));
      const userTokenId = result.user ? await result.user.getIdToken() : null;
      if (userTokenId) {
        const encryptedToken = encryptToken(userTokenId, process.env.REACT_APP_TOKEN_ENCRYPT_KEY!);
        TokenCookieManager.setToken(encryptedToken);
      }
      callAPI(`user/auth/track`, { type: 'google' }, 'POST')
        .then()
        .catch(() => {});
      navigateTo('/');
    }
    // else {
    //   const name = result?.user?.displayName ? result.user.displayName.split(' ') : ['', ''];
    //   const userData = {
    //     email,
    //     firstName: name[0],
    //     lastName: name[1],
    //     authType: 'Google',
    //     plan: null,
    //     promoCode: null,
    //     isAdult: true,
    //     firebaseId: result?.user?.uid,
    //     promotionalEmail,
    //     productUpdateEmail: updateEmail,
    //   };
    //   dispatch(setShowLogin(false));
    //   setSignUpStep && setSignUpStep(2);
    //   dispatch(setSignupViaGoogle(userData));
    //   dispatch(setUser({ email }));
    // }
  } catch (error: any) {
    if (error.code === 'auth/popup-closed-by-user') {
      return;
    }

    Toast('Something Went Wrong', true);
  } finally {
    setGoogleLoader(false);
  }
};

export const handleGoogleSignUp = (
  setGoogleLoader: (loading: boolean) => void,
  setUser: (user: any) => void,
  getUserDetails: (data: { email: string }) => void,
  promotionalEmail: string | null,
  updateEmail: any,
  dispatchSetSignupViaGoogle: AppDispatch,
  setSignUpStep?: (step: number) => void,
) => {
  setGoogleLoader(true);
  signInWithPopup(auth, provider)
    .then(async (result) => {
      let name = result?.user?.displayName ? result.user.displayName.split(' ') : ['', ''];
      const userData = {
        email: result?.user?.email,
        firstName: name[0],
        lastName: name[1],
        authType: 'Google',
        plan: null,
        promoCode: null,
        isAdult: true,
        firebaseId: result?.user?.uid,
        promotionalEmail,
        productUpdateEmail: updateEmail,
      } as any;

      // setSignUpStep(2);
      dispatchSetSignupViaGoogle(setSignupViaGoogle(userData));
      setGoogleLoader(false);
    })
    .catch((error) => {
      Toast('Something went wrong', true);
      setGoogleLoader(false);
    });
};
